import {useFormikContext} from 'formik'
import {FC} from 'react'

import {Text} from '@/components/common/content/Text'
import {ReassuranceBanner} from '@/components/common/form/banner/ReassuranceBanner'
import {FormButton} from '@/components/common/form/FormButton'
import {FormConsentNote} from '@/components/common/form/FormConsentNote'
import {FormContactNote} from '@/components/common/form/FormContactNote'
import {useTrademarkVerificationContent} from '@/content/trademarkVerification'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'

import {ContactDetails} from '../contact/ContactDetails'
import {TrademarkVerificationFields} from '../types'

type ContactStepProps = {submitError: string | null; isReturningCustomer: boolean}

export const ContactStep: FC<ContactStepProps> = ({submitError, isReturningCustomer}) => {
  const {t} = useTranslation()
  const {
    submitButtonText,
    contactDetails: {consentNote},
    reassuranceBanner,
  } = useTrademarkVerificationContent()
  const {status} = useFormikContext<TrademarkVerificationFields>()

  return (
    <>
      <ContactDetails />
      <FormContactNote name="client_note" isCollapsible={isReturningCustomer} />
      {!isReturningCustomer && (
        <div className="banner">
          <ReassuranceBanner description={<Text>{t(reassuranceBanner.contactDescription)}</Text>} />
        </div>
      )}
      <FormButton
        text={t(submitButtonText)}
        dataTest="continueButton"
        status={status}
        submitError={submitError}
      />
      <FormConsentNote note={consentNote.text} linkHrefs={consentNote.linkHrefs} />

      <style jsx>{`
        .banner {
          margin-top: ${theme.spacing[5]};
        }
      `}</style>
    </>
  )
}
